import React from 'react';
import Form from './Form';

const AddBook = () => (
  <Form />
);

export default AddBook;
